import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { AppProvider } from './contexts/AppContext';
import { LoginScreen } from './components/Login';
import { ChatInterface } from './components/Chat';
import { Disclaimer } from './components/Common';
import { useApp } from './contexts/AppContext';
import './App.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const AppContent: React.FC = () => {
  const { state, logout } = useApp();

  return (
    <div className="app">
      {!state.isAuthenticated ? (
        <LoginScreen />
      ) : (
        <>
          <div className="user-profile-section">
            <div className="user-info">
              <div className="user-avatar">
                {state.user?.name?.charAt(0) || 'J'}
              </div>
              <div className="user-details">
                <span className="user-name">{state.user?.name || 'John Doe'}</span>
                <button 
                  className="logout-button"
                  onClick={logout}
                >
                  Log out
                </button>
              </div>
            </div>
          </div>
          <ChatInterface />
        </>
      )}
      <Disclaimer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#55B6A6',
            borderRadius: 8,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          },
        }}
      >
        <AppProvider>
          <AppContent />
        </AppProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App;